exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.summary-statistic-metric-title--small {\n  margin-left: 4px;\n  color: #7c7c7c;\n  font-size: 10px;\n}", ""]);

